import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enLocales from "./en.json";
import esLocales from "./es.json";
import ptLocales from "./pt.json";
import deLocales from "./de.json";
import jaLocales from "./ja.json";
import itLocales from "./it.json";
import detectUserLocale from "src/utils/detectUserLocale";

const storedLang =
  typeof window !== "undefined" ? localStorage.getItem("i18nextLng") : null;

i18n.use(initReactI18next).init({
  resources: {
    en: enLocales,
    es: esLocales,
    pt: ptLocales,
    de: deLocales,
    ja: jaLocales,
    it: itLocales,
  },
  lng: storedLang || "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

if (!storedLang && typeof window !== "undefined") {
  detectUserLocale().then((lang) => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  });
}

export default i18n;
